import { post } from '@core/api/baseApi';
import { WhatsappPayloadType, WhatsappShareResponse } from '@core/types';

const shareByWhatsapp = async (studyInstanceUid: string, shareInfo: WhatsappPayloadType): Promise<WhatsappShareResponse> => {
    return await post(`/studies/${studyInstanceUid}/share-by-whatsapp`, shareInfo); 
};

export default shareByWhatsapp;